import { BaseService } from "./base.service";
import gateway from "@interceptors/gateway.interceptor";

class CardInfoService extends BaseService {
    public deleteCardInfo = async (id: number) => {
        const url = `/card-info/delete/${id}`
        const response = await gateway.delete(url)
        return response.data
    }
    public createCardInfo = async (formData: FormData, idAccomodation: string) => {
        const url = `/card-info/save`;
        const response = await gateway.post(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            params: {
                "idAccomodation": idAccomodation
            }
        });
        return response.data;
    }

    public updateCardInfo = async ( idAccomodation: string, idCardInfo: string, formData: FormData) => {
        const url = `/card-info/update/${idCardInfo}`;
        await gateway.put(url, formData, {
            headers: {
                "Content-Type": "multipart/form-data"
            },
            params: {
                "idAccomodation": idAccomodation
            }
        });
    }

    public findCardInfo = async (idCardInfo: string) => {
        const url = `/card-info/find/${idCardInfo}`;
        const response = await gateway.get(url);
        return response.data;
    }
}

export default new CardInfoService();